import React, { useEffect, useState } from "react";
import { Row, Col, Modal, Table, Divider, Button, Tooltip, notification } from "antd";
import { ExclamationCircleOutlined, PrinterOutlined, CheckOutlined } from "@ant-design/icons";

import api from "../../../services/api";
import { setParametrosLocal } from '../../../services/auth'
import { useStateValue } from '../../../state';
import { isObjetoDiffVazio } from "../../../services/funcoes";
import { imprimirRelatorioJasper } from "../../../services/funcoes";

export default function ModalSelecionaRelatorio({ exibirModal, fecharModal }) {

    const [{ manutencao }, dispatch] = useStateValue();
    const [listaRelatorio, setListaRelatorio] = useState([]);
    const [parametrosImpresao, setParametrosImpresao] = useState();

    useEffect(() => {
        if (!!manutencao.dados && isObjetoDiffVazio(manutencao.dados)) {
            setParametrosImpresao(manutencao.dados.parametrosImpresao);
            retornaRelatorios(manutencao.dados);
        }
    }, [manutencao.dados]);


    function retornaRelatorios(dados) {
        let filtro = [];
        filtro = !!dados.grj_id ? `CodigoGrupo=${dados.grj_id}` : '';
        filtro += `&MostrarList=false`;
        api.get(`RelatorioJasper/Listar?${filtro}`).then((res) => {
            if (res.status === 200) {
                setListaRelatorio(res.data.items);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    function imprimirPedido(record) {
        imprimirRelatorioJasper(record.rel_id, parametrosImpresao);
        fecharModal();
    };

    async function buscarParametrosLocal() {
        try {
            const res = await api.get(`ParametroLocal/BuscarParametrosLocal`);
            if (res.status === 200 && res.data) {
                setParametrosLocal(res.data);
            }
        } catch (erro) {
            console.error("Erro ao buscar parametros local:", erro);
        }
    }

    function DefinirComoPadrão(record) {
        Modal.confirm({
            title: "Confirmar ação",
            content: "Tem certeza de que deseja definir este relatório como padrão?",
            okText: "Sim",
            cancelText: "Não",
            onOk: () => {
                let valores = { ...manutencao.dados.parametrosLocal };
                valores.par_relatorioPedido = record.rel_id;

                if (record.grj_id === 10) { // Corrigido o erro de atribuição
                    let dados = { ...valores };

                    api.put('ParametroLocal/Editar', dados)
                        .then(() => {
                            notification.success({
                                message: 'Operação concluída',
                                description: "Parâmetros do Local salvos com sucesso!"
                            });
                            imprimirPedido(record);
                            fecharModal(); // Fecha a modal apenas se a operação for bem-sucedida
                            buscarParametrosLocal();
                        })
                        .catch(error => {
                            console.log(error);
                            notification.error({
                                message: "Erro",
                                description: "Ocorreu um erro ao salvar os parâmetros."
                            });
                        });
                }
            },
            onCancel: () => {
                console.log("Usuário cancelou a ação");
            }
        });
    }

    return (
        <Modal centered
            title={`Selecione o Relatório que deseja Imprimir`}
            open={exibirModal}
            onCancel={fecharModal}
            maskClosable={false}
            width={800} // Define a largura da modal
            style={{ maxHeight: "80vh", overflowY: "auto" }} // Define altura e rolagem
            footer={null} // Remove os botões de ação do rodapé( "OK" e "Cancelar" )
        >
            <div>
                <div className="tabela">
                    <Table columns={[
                        {
                            title: 'Código',
                            width: '7%',
                            render: ({ rel_id }) => (
                                <div>
                                    <b>{rel_id}</b>
                                </div>
                            ),
                        },
                        {
                            title: 'Nome Relatório',
                            width: '30%',
                            render: ({ rel_nome }) => (
                                <div>
                                    <b>{rel_nome}</b>
                                </div>
                            ),
                        },
                        {
                            title: 'Descrição',
                            width: '50%',
                            render: ({ rel_descricao }) => (
                                <div>
                                    <b>{rel_descricao}</b>
                                </div>
                            ),
                        },
                        {
                            title: 'Ações',
                            dataIndex: '',
                            key: 'x',
                            align: 'center',
                            width: '9%',
                            render: (record) => (
                                <div >
                                    <Row align="middle" justify="center" gutter={[8, 0]}>
                                        <Col>
                                            {/* Tooltip faz aparecer titulo ao colcoar mouse em cima do icone */}
                                            <Tooltip title="Definir como relatório padrão">
                                                <Button
                                                    type="default"
                                                    icon={<CheckOutlined />}
                                                    onClick={() => DefinirComoPadrão(record)}
                                                >
                                                </Button>
                                            </Tooltip>
                                        </Col>
                                        <Col>
                                            <Tooltip title="Imprimir relatório">
                                                <Button
                                                    type="default"
                                                    icon={<PrinterOutlined />}
                                                    onClick={() => imprimirPedido(record)}
                                                >
                                                </Button>
                                            </Tooltip>
                                        </Col>
                                    </Row>
                                </div>
                            ),
                        },
                    ]} dataSource={listaRelatorio} locale={{
                        emptyText: (
                            <Row>
                                <Col span={24}>
                                    <Divider orientation="center">
                                        <ExclamationCircleOutlined /> Nenhum Registro Encontrado
                                    </Divider>
                                </Col>
                            </Row>
                        )
                    }} />
                </div>
            </div>
        </Modal>
    );
}